import { createSelector } from 'reselect'

import { selectConfigurationState } from './selectConfigurationState'

export const selectConfigurationLoadingStatus = createSelector(
  [selectConfigurationState],
  ({ status }) => status
)
